import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconPause = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.008 21.2055H5.551C5.29851 21.2055 5.05637 21.1052 4.87783 20.9267C4.6993 20.7481 4.599 20.506 4.599 20.2535V3.74749C4.599 3.49492 4.69927 3.25267 4.87777 3.07398C5.05628 2.89528 5.29842 2.79476 5.551 2.79449H9.008C9.26031 2.79476 9.5022 2.89518 9.68052 3.07368C9.85884 3.25219 9.959 3.49418 9.959 3.74649V20.2535C9.959 20.5057 9.85881 20.7476 9.68046 20.926C9.50211 21.1043 9.26022 21.2055 9.008 21.2055Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.387 21.2055H15.057C14.9236 21.2055 14.7915 21.1792 14.6682 21.1282C14.5449 21.0771 14.4329 21.0023 14.3386 20.9079C14.2442 20.8136 14.1694 20.7016 14.1183 20.5783C14.0673 20.455 14.041 20.3229 14.041 20.1895V3.81049C14.041 3.54103 14.148 3.28261 14.3386 3.09207C14.5291 2.90154 14.7875 2.79449 15.057 2.79449H18.387C18.5203 2.79463 18.6522 2.82101 18.7753 2.87214C18.8984 2.92327 19.0103 2.99814 19.1044 3.09249C19.1986 3.18683 19.2732 3.2988 19.3241 3.42199C19.375 3.54519 19.4011 3.6772 19.401 3.81049V20.1895C19.4011 20.3228 19.375 20.4548 19.3241 20.578C19.2732 20.7012 19.1986 20.8132 19.1044 20.9075C19.0103 21.0018 18.8984 21.0767 18.7753 21.1279C18.6522 21.179 18.5203 21.2054 18.387 21.2055Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
